import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

// account info
const accountInfoSelector = (state: RootState) => state.layouts.accountInfo;

export const accountInfoDataSelector = createSelector(
  accountInfoSelector,
  (state) => state.data
);
export const accountInfoStatusSelector = createSelector(
  accountInfoSelector,
  (state) => state.status
);

// role menu
const roleMenuSelector = (state: RootState) => state.layouts.roleMenu;

export const roleMenuDataSelector = createSelector(
  roleMenuSelector,
  (state) => state.data
);
export const oleMenuStatusSelector = createSelector(
  roleMenuSelector,
  (state) => state.status
);

// permission item
export const permissionItemSelector = (state: RootState) =>
  state.layouts.permissionItem.data;
